"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditClaimedVaccinationDtoCodeEnum = void 0;
exports.instanceOfDocumentAuditClaimedVaccinationDto = instanceOfDocumentAuditClaimedVaccinationDto;
exports.DocumentAuditClaimedVaccinationDtoFromJSON = DocumentAuditClaimedVaccinationDtoFromJSON;
exports.DocumentAuditClaimedVaccinationDtoFromJSONTyped = DocumentAuditClaimedVaccinationDtoFromJSONTyped;
exports.DocumentAuditClaimedVaccinationDtoToJSON = DocumentAuditClaimedVaccinationDtoToJSON;
exports.DocumentAuditClaimedVaccinationDtoToJSONTyped = DocumentAuditClaimedVaccinationDtoToJSONTyped;
const DocumentAuditClaimedDoseDto_1 = require("./DocumentAuditClaimedDoseDto");
/**
 * @export
 */
exports.DocumentAuditClaimedVaccinationDtoCodeEnum = {
    Covid19: 'COVID_19',
    Hepatitis: 'HEPATITIS',
    Influenza: 'INFLUENZA',
    MeaslesMumpsRubella: 'MEASLES_MUMPS_RUBELLA',
    Tdap: 'TDAP',
    Varicella: 'VARICELLA'
};
/**
 * Check if a given object implements the DocumentAuditClaimedVaccinationDto interface.
 */
function instanceOfDocumentAuditClaimedVaccinationDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('completed' in value) || value['completed'] === undefined)
        return false;
    if (!('hasTiter' in value) || value['hasTiter'] === undefined)
        return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined)
        return false;
    if (!('doses' in value) || value['doses'] === undefined)
        return false;
    return true;
}
function DocumentAuditClaimedVaccinationDtoFromJSON(json) {
    return DocumentAuditClaimedVaccinationDtoFromJSONTyped(json, false);
}
function DocumentAuditClaimedVaccinationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'completed': json['completed'],
        'hasTiter': json['hasTiter'],
        'expiresAt': (json['expiresAt'] == null ? null : new Date(json['expiresAt'])),
        'doses': (json['doses'].map(DocumentAuditClaimedDoseDto_1.DocumentAuditClaimedDoseDtoFromJSON)),
    };
}
function DocumentAuditClaimedVaccinationDtoToJSON(json) {
    return DocumentAuditClaimedVaccinationDtoToJSONTyped(json, false);
}
function DocumentAuditClaimedVaccinationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'completed': value['completed'],
        'hasTiter': value['hasTiter'],
        'expiresAt': (value['expiresAt'] == null ? null : value['expiresAt'].toISOString()),
        'doses': (value['doses'].map(DocumentAuditClaimedDoseDto_1.DocumentAuditClaimedDoseDtoToJSON)),
    };
}
//# sourceMappingURL=DocumentAuditClaimedVaccinationDto.js.map